export default __webpack_public_path__ + "static/media/2930 spice rack E side.02fed04b.png";